import ScheduleOption from './ScheduleOption'

import {
  OptionsGrid,
  ProfessionalsGrid,
  ProfessionalPicture,
  SmallButton,
  Row,
  Column,
  SubTitle
} from './styles'

export default function ScheduleOptionList ({
  options = {},
  onSelect: handleSelect
}) {
  const {
    availableCombinations,
    availableHandAndFootTimes,
    availableHandTimes,
    availableFootTimes,
    availableProfessionals
  } = options

  const hasHandOrFootOptions = availableHandTimes?.length > 0 || availableFootTimes?.length > 0
  const hasProfessionalOptions = availableProfessionals?.length > 0
  const hasCombinationOptions = availableCombinations?.length > 0
  const hasHandAndFootOptions = availableHandAndFootTimes?.length > 0

  const optionsData = hasHandOrFootOptions ? [...availableHandTimes, ...availableFootTimes]
    : hasProfessionalOptions ? availableProfessionals
    : hasCombinationOptions ? availableCombinations
    : hasHandAndFootOptions ? availableHandAndFootTimes
    : null

  const handleSelectProfessional = professional => {
    handleSelect ({ professional })
  }

  if (!options || Object.keys (options).length === 0) {
    return null
  }

  if (hasProfessionalOptions) return (
    <ProfessionalsGrid>
      {availableProfessionals.map ((professional, index) => (
        <SmallButton
          key={index}
          onClick={() => handleSelectProfessional (professional)}
          style={{margin: 0}}
        >
          <Column>
            <Row style={{position: 'relative', marginBottom: 4}}>
              <ProfessionalPicture src={professional.profile_picture}/>
            </Row>
            <SubTitle>
              {professional.nickname}
            </SubTitle>
          </Column>
        </SmallButton>
      ))}
    </ProfessionalsGrid>
  )
    
  return (
    <OptionsGrid>
      {optionsData.map ((option, index) => (
        <ScheduleOption
          key={index}
          data={option}
          onSelect={handleSelect}
        />
      ))}
    </OptionsGrid>
  )
}
